// initial state
const state = {
  editing: false,
  blob: null,
  imgname: null,
  imgurl: null
}

// getters
const getters = {

}

// actions
const actions = {

}

// mutations
const mutations = {
  changeEditing (state, bool) {
    state.homepage_id = bool
  },
  setBlob (state, blob) {
    state.blob = blob
  },
  setImgname (state, imgname) {
    state.imgname = imgname
  },
  setImgurl (state, imgurl) {
    state.imgurl = imgurl
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/globals.js